export default function createCompanyCertifications(
  companyCerts,
  qualifications,
) {
  const items = [];
  const certs =
    typeof companyCerts === 'string'
      ? [JSON.parse(companyCerts)]
      : companyCerts.map((c) => JSON.parse(c));
  certs.forEach((i) => {
    const p = qualifications.find(
      (s) => s.id === Number(i.field_qualification),
    );
    if (p)
      items.push({
        label: p.name,
        year: new Date(i.field_date_achieved).getFullYear(),
        productId: p.productTypes,
        image: {
          url: p?.qualificationImage.url,
          alt: p.name,
        },
      });
  });
  return items;
}
